import React from "react"
import PropTypes from "prop-types"

import DebouncedInput from "../helpers/DebouncedInput"

import * as simpleBlogLatestSectionSearchStyles from "../styles/SimpleBlogLatestSectionSearch.module.css"

function SimpleBlogLatestSectionSearch(props) {
  const [isSearching, setIsSearching] = React.useState(false)
  const [resultsTimestamp, setResultsTimestamp] = React.useState(null)

  React.useEffect(() => {
    if (props.resultsTimestamp !== resultsTimestamp) {
      setIsSearching(false)
      setResultsTimestamp(props.resultsTimestamp)
    }
  }, [props.resultsTimestamp, resultsTimestamp])

  const onDataInput = async ({ value }) => {
    if (value.length > 0 && value.length < 3) return

    setIsSearching(true)
    props.onTokenChange(value)
  }

  return (
    <div className={simpleBlogLatestSectionSearchStyles.wrapper}>
      <div
        className={`row ${props.className} ${simpleBlogLatestSectionSearchStyles.wrapperOpen}`}
      >
        <div className={`col-md-11 col-sm-11 col-md-11 col-lg-8 ${simpleBlogLatestSectionSearchStyles.holder}`}>
          <div className={simpleBlogLatestSectionSearchStyles.widget}>
            <span className={simpleBlogLatestSectionSearchStyles.widgetInput}>
              <DebouncedInput
                className={simpleBlogLatestSectionSearchStyles.searchField}
                placeholder={props.placeholderText}
                initialValue={``}
                isReadOnly={isSearching}
                onDataInput={onDataInput}
              />
              <span style={{ display: "flex" }}>
                <div
                  className={`spinner-border text-dark ${
                    isSearching
                      ? simpleBlogLatestSectionSearchStyles.spinnerActive
                      : simpleBlogLatestSectionSearchStyles.spinnerInactive
                  }`}
                  role="status"
                ></div>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

SimpleBlogLatestSectionSearch.propTypes = {
  placeholderText: PropTypes.string.isRequired,
  resultsTimestamp: PropTypes.number,
  onTokenChange: PropTypes.func.isRequired,
}

export default SimpleBlogLatestSectionSearch
